import { Suspense, memo } from 'react';
import { Skeleton, SkeletonProps } from 'antd';
import { useAppSelector } from 'app/hooks';
import ErrorBoundary from 'components/ErrorBoundary';
import { selectBrandCode } from 'services/brand/brandSelectors';
import { lazyImport, type LazySvgProps } from './utils';

/* Icon skeleton component */
function IconSkeleton(props: SkeletonProps) {
  return <Skeleton.Avatar size='large' shape='circle' {...props} />;
}
export const MemoizedIconSkeleton = memo(IconSkeleton);

function LazySvg({
  name,
  subFolder,
  qaSelector,
  fallback = <MemoizedIconSkeleton active />,
  ...rest
}: LazySvgProps) {
  const brandCode = useAppSelector(selectBrandCode);
  const LazyIcon = lazyImport({
    name,
    subFolder,
    folder: brandCode,
  });

  return (
    <ErrorBoundary fallback={fallback}>
      <Suspense fallback={fallback}>
        <LazyIcon data-qa-selector={qaSelector} {...rest} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default memo(LazySvg);
